<template>
    <div class="footer-popUp" ref="footer" v-if="!hideFooter ">

        <div>
            We can't cover everything about your benefits on this website and sometimes the {{fundOrScheme}} Rules may change. If there are any discrepancies between this website and the {{fundOrScheme}}'s Trust Deed and Rules, the Trust Deed and Rules always prevails. © {{new Date().getFullYear()}} Lane Clark &amp; Peacock LLP. This site is managed by Lane Clark &amp; Peacock LLP ("LCP") for members of {{formatTheSchemeName}} (referred to in our terms and conditions as the “Scheme”) acting in the capacity of administrators appointed by the {{trusteeWording}}
            <a :href="termsUrl" target="_blank"> Terms &amp; Conditions </a>
            <template v-if="privacyUrl"> | <a :href="privacyUrl" target="_blank"> {{schemeName}}'s Privacy Notice</a></template>
        </div>
        <div><span class="icon-x-circle close" @click="closeFooter"/></div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import TERMS_AND_CONDITIONS_PATH from '@/constants/termsAndConditionsPath';

export default {
    name: 'siteFooter',
    data () {
        return {
            hideTermsBar: false,
        };
    },
    mounted () {
        this.localStorageDismiss();
    },
    methods: {
        closeFooter () {
            localStorage.setItem('hideTermsBar', dayjs().add(1, 'hour').valueOf());
            this.hideTermsBar = true;
            this.$store.commit('closeFooter');
        },
        localStorageDismiss () {
            this.hideTermsBar = false;
            const hideTermsBar = localStorage.getItem('hideTermsBar');
            if (hideTermsBar) {
                if (hideTermsBar > dayjs().valueOf()) {
                    this.hideTermsBar = true;
                    this.$store.commit('closeFooter');
                }
            }
        },
    },
    computed: {
        ...mapGetters('clientConfig', [
            'formatTheSchemeName',
        ]),
        schemeName () {
            return this.$store.state.clientConfig.schemeName;
        },
        trusteeWording () {
            return this.$store.state.clientConfig.trusteeWording;
        },
        fundOrScheme () {
            return this.$store.state.clientConfig.fundOrScheme;
        },
        termsUrl () {
            let termsToShow = '';
            if (this.$store.state.clientConfig.customTerms !== undefined) {
                termsToShow = this.$store.state.clientConfig.customTerms;
            } else {
                termsToShow = TERMS_AND_CONDITIONS_PATH;
            }
            return termsToShow;
            // return this.$store.state.clientConfig.customTerms !== undefined ? this.$store.state.clientConfig.customTerms : '/documents/Terms and Conditions.pdf';
        },
        privacyUrl () {
            return this.$store.state.clientConfig.privacyUrl || '/information';
        },

        hideFooter () {
            return this.$route.meta.hideFooter || this.hideTermsBar;
        },
    },
};
</script>

<style lang="scss" scoped>
.footer-popUp{
    background: var(--primaryColour);
    padding: 10px;
    position: absolute;
    bottom: 0;
    width:100%;
    font-size: 12px;
    text-align: center;
    z-index:11;
    display:flex;
    color: #ffffff;
    a{
        color: #ffffff;
        cursor: pointer;
        text-decoration: underline;
    }
    .close{
        cursor: pointer;
        color: #ffffff;
    }
}
</style>
